import { render, staticRenderFns } from "./ProjectsDisplayComponent.vue?vue&type=template&id=78ae3192&scoped=true&"
import script from "./ProjectsDisplayComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectsDisplayComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsDisplayComponent.vue?vue&type=style&index=0&id=78ae3192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ae3192",
  null
  
)

export default component.exports